"use client";
import React from "react";
import { fetchAlgoliaProduct } from "@/helpers/shoppingListHelper";
import debounce from "lodash/debounce";
import {
  useAppDispatch,
  useAppSelector,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "@/utils/hooks/reactUseCustomHooks";
import {
  renameCustomMangementList,
  setShoppingMessage,
  updateShoppingListByStore,
} from "@/utils/redux/shoppingList";
import {
  addOrUpdateListItemsToCart,
} from "@/utils/redux/shoppingList/actions";
import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Card,
  Text,
} from "@dxp-feed/ui";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import Loader from "@/components/Loader";
import { AvailableOffers } from "./_components/AvailableOffers";
import { AutomaticAddedOffers } from "./_components/AutomaticAddedOffers";
import { offersRemovedFromStorage } from "@/utils/redux/favOffers";
import { useStoreDetails } from "@/utils/hooks/useStoreDetails";
import { useGigyaAccountInfo } from "@/helpers/gigyaCentralSsoHook";
import {
  setCustomManageList, updateShoppingList
} from "@/utils/redux/shoppingList";
import { setShoppingListPageData } from "@/utils/redux/ManagelListingSlice";
import AnimatedQuantityButton from "@/components/QuantityButton";
import Link from "next/link";
import { setFavouriteMessage } from "@/utils/redux/favouriteProduct";
import { useLogin } from "@/helpers/useCommonFunctions";
import OfferCard from "@/components/OfferCard";
import { flyerEvents } from "@/components/FlyerIframe";
interface CartPanelProps {
  productCount: number;
  countHandler: (count: number | ((prev: number) => number)) => void;
  setIsPanelOpen?: (isOpen: boolean) => void;
  sidePanelOpen?: boolean;
  showOffers?: boolean;
  openDialog?: any;
}

const CartSidePanel = ({
  productCount,
  setIsPanelOpen,
  countHandler,
  sidePanelOpen,
  showOffers,
  openDialog,
}: CartPanelProps) => {
  const [products, setProducts] = useState<Record<string, any>>({});
  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [loader, setLoader] = useState(false);
  const dispatch = useAppDispatch();


  const { storeID, storeRegion } = useStoreDetails();

  const selectedStore: any = useAppSelector(
    (state) => state?.selectedStore.data
  );
  const shoppingList: Record<string, any> = useAppSelector(
    (state) => state?.shoppingListSlice
  );

  const {
    loggedIn: userLoggedIn,
    uid: uid,
    scene,
  } = useAppSelector((state) => state.gigyaslice);
  const { favOffers, offersToBeAdded, isLoading } = useAppSelector(
    (state) => state.favoirateOffersSlice
  );
  // const pathName = usePathname();
  const searchParams = useSearchParams();
  const isHash = [...searchParams.keys()].includes("hash");
  const gigyaToken = useGigyaAccountInfo();

  useEffect(() => {
    if (storeID) {
      const updatedShoppingItems =
        shoppingList?.shoppingListProducts?.products?.map(
          (item: { item_id: string }) => ({
            ...item,
            item_id: `${item?.item_id?.split("_").slice(0, 2).join("_")}_${storeID}`,
          })
        );
      if (updatedShoppingItems) {
        dispatch(updateShoppingListByStore(updatedShoppingItems));
      }
      onStoreChangefetchProducts();
    }
  }, [storeID]);


  // const saveDataAndLogin = async (userInfo: {
  //   uid: string;
  //   id_token: string;
  // }) => {


  //   if (
  //     (shoppingList?.shoppingListProducts?.products?.length || shoppingList?.shoppingListProducts?.custom?.length) &&
  //     shoppingList?.isAuthenticated === false
  //   ) {
  //     let shoppingProducts = []
  //     let shoppingCustoms = []

  //     if (shoppingList?.shoppingListProducts?.products?.length > 0) {
  //       shoppingProducts = shoppingList?.shoppingListProducts?.products
  //         ?.map((item: {
  //           quantity: any; item_id: string; id: string; product_type: string
  //         }) => {
  //           let newItemId = item.item_id;
  //           const parts = newItemId.split('_');
  //           const lastPart = parts[parts.length - 1];
  //           if (!isNaN(Number(lastPart))) {
  //             parts.pop();
  //             newItemId = parts.join('_');
  //           }

  //           return {
  //             item_id: newItemId,
  //             product_type: item?.product_type,
  //             quantity: item?.quantity
  //           };
  //         });
  //     }

  //     if (shoppingList?.shoppingListProducts?.custom?.length > 0) {
  //       shoppingCustoms = shoppingList?.shoppingListProducts?.custom
  //         ?.map((item: {
  //           meta: any;
  //           quantity: any; item_id: string; id: string; product_type: string
  //         }) => {
  //           return {
  //             item_id: "0",
  //             product_type: item?.product_type,
  //             quantity: item?.quantity,
  //             meta: item?.meta

  //           };
  //         });
  //     }

  //     const mergedShoppingList = [
  //       ...(shoppingProducts),
  //       ...(shoppingCustoms),
  //     ];

  //     if (mergedShoppingList?.length) {
  //       dispatch(resetShoppingList());
  //       const payload = {
  //         userToken: userInfo.id_token,
  //         items: mergedShoppingList,
  //         storeId: selectedStore?.storeNumber
  //       };
  //       const saveResult = await dispatch(addOrUpdateListItemsToCart(payload));

  //       if (saveResult.type === "add_or_update_list_to_cart/fulfilled") {
  //         dispatch(
  //           getShoppingCartItems({
  //             userToken: userInfo?.id_token,
  //             storeId: selectedStore?.storeNumber,
  //           })
  //         );
  //       }
  //     }
  //   } else {
  //     dispatch(
  //       getShoppingCartItems({
  //         userToken: userInfo?.id_token,
  //         storeId: selectedStore?.storeNumber,
  //       })
  //     );
  //   }
  //   dispatch(
  //     fetchFavouriteProducts({
  //       userToken: userInfo?.id_token,
  //       storeId: selectedStore?.storeNumber,
  //     })
  //   );

  // };

  // const count =
  //   (shoppingList?.shoppingListProducts?.products?.reduce(
  //     (acc: number, product: any) => acc + (product?.quantity ?? 0),
  //     0
  //   ) ?? 0) +
  //   (shoppingList?.shoppingListProducts?.custom?.reduce(
  //     (acc: number, item: any) => acc + (item?.quantity ?? 0),
  //     0
  //   ) ?? 0);

  const count =
    (shoppingList?.shoppingListProducts?.products?.length ?? 0) +
    (shoppingList?.shoppingListProducts?.custom?.length ?? 0);

  useEffect(() => {
    const offersCount = (favOffers?.favouriteOffers?.length ?? 0);
    countHandler(count + (userLoggedIn ? offersCount : offersToBeAdded?.length));
  }, [shoppingList?.shoppingListProducts?.products, favOffers, userLoggedIn, offersToBeAdded]);


  // useEffect(() => {
  //   (async () => {
  //     const response = await gigyaToken();
  //     console.log("userLoggedIn", userLoggedIn, "response", response,"aaa", selectedStore.storeNumber)
  //     if (response.idToken != "" && response.uid != "" && userLoggedIn) {
  //       console.log("userLoggedIn---")

  //       await saveDataAndLogin({
  //         id_token: response.idToken,
  //         uid: response.uid,
  //       });
  //     }
  //   })()
  // }, [userLoggedIn, selectedStore.storeNumber]);

  const onStoreChangefetchProducts = async () => {
    try {
      // setLoader(true);
      const filteredProducts = shoppingList?.shoppingListProducts?.products?.filter(
        (product: { quantity: number }) => (product?.quantity ?? 0) > 0
      );

      const result = await fetchAlgoliaProduct(
        filteredProducts,
        storeID,
        storeRegion
      );

      const missingItems = shoppingList?.shoppingListProducts?.products
        ?.filter(
          (isMissing: { item_id: string }) =>
            !result.some((cart: any) => cart?.articleNumber + "_" + cart?.uom == isMissing?.item_id?.split('_').slice(0, 2).join('_'))
        ).map((item: { item_id: string; id: string; product_type: string }) => {
          let newItemId = item.item_id;
          const parts = newItemId.split('_');
          const lastPart = parts[parts.length - 1];
          if (!isNaN(Number(lastPart))) {
            parts.pop();
            newItemId = parts.join('_');
          }

          return {
            item_id: newItemId,
            product_type: item.product_type,
            quantity: 0
          };
        })
      if (missingItems.length > 0) {
        if (!userLoggedIn) {
          dispatch(
            renameCustomMangementList({
              userToken: "",
              items: missingItems,
              storeId: storeID,

            })
          );
        } else {
          const userResponse = await gigyaToken();
          if (userResponse.idToken) {
            const payload = {
              userToken: userResponse.idToken,
              items: missingItems,
              storeId: storeID
            };
            dispatch(addOrUpdateListItemsToCart(payload));
          }
        }
      }
      setProducts(result);

    } catch (err) {
      console.log("Error", err);
    } finally {
      // setLoader(false);
    }
  };

  const fetchProducts = async () => {
    try {
      setLoader(true);
      const filteredProducts = shoppingList?.shoppingListProducts?.products?.filter(
        (product: { quantity: number }) => (product?.quantity ?? 0) > 0
      );

      const result = await fetchAlgoliaProduct(
        filteredProducts,
        storeID,
        storeRegion
      );
      setProducts(result);

    } catch (err) {
      console.log("Error", err);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (sidePanelOpen) {
      dispatch(setFavouriteMessage());
      dispatch(setShoppingMessage());
      fetchProducts();
    }
  }, [shoppingList?.shoppingListProducts?.products?.length, userLoggedIn, sidePanelOpen]);


  const router = useRouter();
  const { loadLogin } = useLogin();
  const [availableOffers, setAvailableOffers] = useState<any>([]);
  const [automaticAddedOffers, setAutomaticAddedOffers] = useState<any>([]);

  useEffect(() => {
    if (favOffers && !isLoading) {
      setAvailableOffers(favOffers?.favouriteOffers ?? []);
      setAutomaticAddedOffers(favOffers?.basketBuilderOffers ?? []);
    }
    if (!userLoggedIn && isHash) {
      if (typeof window != "undefined") {
        const offers = sessionStorage.getItem("offers") || "[]";
        let existingOffers: any[] = JSON.parse(offers);
        setAvailableOffers(existingOffers);
      }
    }
  }, [favOffers, offersToBeAdded]);

  const deleteOffersFromStorage = (selectedOffer: any) => {
    const storedOffers = sessionStorage.getItem("offers") || "[]";
    const remainingOffers = JSON.parse(storedOffers).filter(
      (offer: any) => offer.offerId !== selectedOffer.offerId
    );
    sessionStorage.setItem("offers", JSON.stringify(remainingOffers));
    dispatch(offersRemovedFromStorage(remainingOffers));
  };
  const handleCartProductChange = (itemNumber: number = 0) => {
    if (itemNumber == 0) {
      setTimeout(() => {
        setLoader(false);
      }, 500);
    } else {
      setLoader(true);
    }
  };

  const hasValues =
    products &&
    Object.values(products).some(
      (array) => Array.isArray(array) && array.length > 0
    );

  const handleNavigation = () => {
    const isEmpty = products?.length + favOffers?.favouriteOffers?.length === 0;
    router.push(isEmpty ? "/products" : "/shopping-list");
    setIsPanelOpen?.(false);
  };

  const debouncedAddToCart = useCallback(
    debounce(async (data: any) => {
      try {
        setIsButtonClicked(true);
        let storedItems = JSON.parse(localStorage.getItem("flyerItems") || "[]");
        if (!userLoggedIn) {
          const { item_id, quantity } = data[0]
          if (!quantity) {
            const newFlyerItems = storedItems.filter((i: any) => i != item_id);
            localStorage.setItem("flyerItems", JSON.stringify(newFlyerItems));
          }
          dispatch(
            renameCustomMangementList({
              items: data,
              storeId: storeID
            })
          );
        } else {
          const userResponse = await gigyaToken();
          if (data.length > 0 && userResponse.idToken) {
            const payload = {
              userToken: userResponse.idToken,
              items: data,
              storeId: storeID
            };
            const { meta, quantity } = data[0];
            const { item_Id } = JSON.parse(meta)
            if (!quantity) {
              const newFlyerItems = storedItems.filter((i: any) => i != item_Id)
              localStorage.setItem("flyerItems", JSON.stringify(newFlyerItems));
            }
            await dispatch(addOrUpdateListItemsToCart(payload));
          }
        }
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        setIsButtonClicked(false);
      }
    }, 500),
    [userLoggedIn, storeID, dispatch, gigyaToken]
  );


  const updateListItem = useCallback(
    (data: any) => {
      debouncedAddToCart(data);
    },
    [debouncedAddToCart]
  );
  const updateQuantity = (item_id: string, quantity: number) => {
    if (!quantity) {
      flyerEvents.emit("flyerload", item_id);
    }
    dispatch(updateShoppingList({ payload: { item_id, quantity } }));
  };

  const handleProductLinkClick = (val: boolean) => {
    setTimeout(() => {
      setIsPanelOpen?.(false);
    }, 1000);
  };


  return !loader ? (
    <Box as="div" className="h-full bg-brandWhite">
      {sidePanelOpen && (
        <Box
          key={""}
          as="div"
          role="contentinfo"
          className="relative  h-[calc(100%-146px)] top-[77px] overflow-y-scroll z-1"
          aria-hidden={!sidePanelOpen}
          tabIndex={sidePanelOpen ? 0 : -1}
        >
          {/* 
          {products.length > 0 && products?.map((item: any, productIndex: number) => (
            <Box
              key={productIndex}
              as="div"
              className="bg-brandWhite px-6"
            >
              <React.Fragment key={item.articleNumber}>
                <CartAddedProducts
                  item={item}
                  Uid={uid as string}
                  userLoggedIn={userLoggedIn}
                  onResponseProductChange={handleCartProductChange}
                  setIsPanelOpen={setIsPanelOpen}
                />
              </React.Fragment>
            </Box>

          ))} */}

          <Accordion multiplePanelOpen defaultActiveKey={["customList", "productsList"]} className={`${products.length == 0 && !hasValues && shoppingList?.shoppingListProducts.custom.length == 0 && availableOffers?.length == 0 && automaticAddedOffers?.length == 0 ? "h-full w-full flex flex-col items-center justify-center" : ""}`}>
            {shoppingList?.shoppingListProducts.custom.length > 0 && (
              <AccordionItem
                id={"customList"}
                className="py-0 px-0 w-full !border-0"
              >
                <AccordionHeader
                  id={"customList"}
                  className="font-bold !px-6 border-b-[2px] !border-grey250 !py-3 text-base text-brandBlack [&>span]:min-w-[13px] [&>span>.demo-icon]:text-brandSecondary [&>span]:flex [&>span:first-child]:w-full"
                >
                  Custom List Items
                  <Box as="span" className="ml-auto text-body font-primaryFont font-normal">{shoppingList?.shoppingListProducts?.custom?.length} item{shoppingList?.shoppingListProducts?.custom?.length == 1 ? "" : "s"}</Box>
                </AccordionHeader>
                <AccordionPanel
                  id={"customList"}
                  className="px-6 [&>div]:px-0 [&>div]:pt-0 [&>div]:pb-6 [&>div]:text-body [&>div]:font-normal"
                >
                  <Box as="div" className={`flex flex-col max-h-[270px] overflow-y-scroll custom-scroll ${shoppingList?.shoppingListProducts?.custom?.length <= 4 ? "!pr-0" : ""}`}>
                    {shoppingList?.shoppingListProducts?.custom?.slice()
                      ?.sort((a: any, b: any) =>
                        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                      ).map(
                        (item: any, index: any) => {
                          return (
                            <Box as="div"
                              key={`${userLoggedIn ? item?.id : item?.item_id}-${index}`}
                              className="border-b-2 border-grey250"
                            >
                              <Box as="div" className="flex items-center py-2">
                                <Text as="label"
                                  htmlFor={`checkbox-${item?.item_id}`}
                                  className="text-body text-brandBlack peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer break-all"
                                >
                                  {item.meta && JSON.parse(item.meta).name.length > 100 ? JSON.parse(item.meta).name.slice(0, 100) + "..." : JSON.parse(item.meta).name}
                                </Text>
                                <Box
                                  as="div"
                                  className="text-brandSecondary h-[48px] flex justify-center items-center ml-auto"
                                >
                                  <AnimatedQuantityButton
                                    isBtnOutline={true}
                                    isFullView={true}
                                    className="ml-4"
                                    productQuantity={item.quantity}
                                    clickCallbackHandler={(quantity) => {
                                      updateListItem([
                                        {
                                          item_id: userLoggedIn ? "0" : item?.item_id,
                                          quantity,
                                          meta: item?.meta,
                                          product_type: "Custom",
                                          id: Number(item?.id)
                                        }
                                      ]);
                                      updateQuantity(item.item_id, quantity);
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Box>
                          )
                        }
                      )}
                  </Box>
                </AccordionPanel>
              </AccordionItem>
            )}

            {products.length == 0 && availableOffers?.length === 0 && automaticAddedOffers?.length === 0 && !hasValues &&
              (
                <Box as="div" className={`bg-white w-full flex flex-col items-center justify-center`}>
                  <Box as="div">
                    {shoppingList?.shoppingListProducts?.products.length == 0 && products?.length == 0 && shoppingList?.shoppingListProducts?.custom.length == 0 &&
                      <Box
                        as="div"
                        className="!pt-6 md:!pt-12 lg:!pt-[40px] pb-6 md:pb-12 lg:pb-8 text-center"
                      >
                        <Box as="div" className="flex justify-center">
                          <Text
                            as="span"
                            className="icon-folder text-[46.67px] text-brandSecondary"
                          />
                        </Box>
                        <Box as="div" className="mt-4">
                          <Text
                            as="p"
                            className="font-primaryFont font-bold text-base text-black"
                          >
                            You currently don’t have any items in<br /> your shopping list.
                          </Text>
                          <Text as="p" className="text-body text-black mt-2">
                            To build your shopping list, start browsing products<br /> by clicking on the button below.
                          </Text>
                        </Box>
                        <Box as="div" className="mt-6">
                          <Button
                            asChild
                            variant="primary"
                            className="font-normal !text-body w-full 2xs:w-auto  max-w-[164px] max-h-10"
                          >
                            <Link
                              className="py-[9.5px] px-6 !text-body text-brandWhite"
                              href={"/products"}
                              aria-label={"Browse Products"}
                              onClick={() => setIsPanelOpen?.(false)}
                            >
                              Browse Products
                            </Link>
                          </Button>
                        </Box>
                      </Box>
                    }
                  </Box>
                </Box>
              )}
            {products.length > 0 && (
              <AccordionItem
                id={"productsList"}
                className="py-0 px-0 !border-0 bg-brandWhite"
              >
                <AccordionHeader
                  id={"productsList"}
                  className="font-bold !px-6 border-b-[2px] !border-grey250 !py-3 text-base text-brandBlack [&>span]:min-w-[13px] [&>span>.demo-icon]:text-brandSecondary [&>span]:flex [&>span:first-child]:w-full"
                >  Products
                  <Box as="span" className="ml-auto text-body font-primaryFont font-normal">{products?.length} item{products?.length == 1 ? "" : "s"}</Box>
                </AccordionHeader>
                <AccordionPanel
                  id={"productsList"}
                  className="px-6 [&>div]:px-0 [&>div]:pt-4 [&>div]:text-body [&>div]:font-normal"
                >
                  {products.length > 0 &&
                    products?.map((item: any, productIndex: number) => (
                      <Box key={productIndex} as="div" className="bg-brandWhite">
                        <Box key={item.articleNumber}>
                          {/* <CartAddedProducts
                          item={item}
                          Uid={uid as string}
                          userLoggedIn={userLoggedIn}
                          onResponseProductChange={handleCartProductChange}
                          setIsPanelOpen={setIsPanelOpen}
                        /> */}
                          <OfferCard
                            item={item}
                            isShopingView={true}
                            isCartSidebarView={true}
                            className="pb-4 w-full"
                            displayedFrom={"shoppingListPage"}
                            onProductLinkClick={handleProductLinkClick}
                            fromCartSide={true}
                          />
                        </Box>
                      </Box>
                    ))}
                </AccordionPanel>
              </AccordionItem>
            )}
          </Accordion>

          {/* {products.length == 0 && !hasValues && (
            <Box as="div" className="bg-white">
              <Text
                as="div"
                className="text-base font-bold text-brandBlack py-3 px-6"
              >
                {"You currently do not have any products in your shopping list"}
              </Text>
            </Box>
          )} */}

          <Box as="div" className="bg-brandWhite">
            {availableOffers?.length > 0 && showOffers && (
              <AvailableOffers
                availableOffers={availableOffers}
                deleteOffersFromStorage={deleteOffersFromStorage}
                openDialog={openDialog}
              />
            )}
            {automaticAddedOffers?.length > 0 && (userLoggedIn) && showOffers && (
              <AutomaticAddedOffers
                automaticAddedOffers={automaticAddedOffers}
              />
            )}
          </Box>
        </Box>
      )}
      {(products.length !== 0 || hasValues || shoppingList?.shoppingListProducts.custom.length !== 0 || availableOffers?.length > 0) && (
        <Box
          as="div"
          className="flex bg-brandWhite shadow-[0_-3px_7px_0_rgba(0,0,0,0.28)] pt-3 px-6 !py-[12px] absolute bottom-0 left-0 right-0 h-[68.78px] z-[2]"
        >
          <Box
            as="div"
            className={`w-full flex items-center`}
            onBlur={(e: React.FocusEvent<HTMLDivElement>) => {
              const target = e.currentTarget;
              setTimeout(() => {
                if (!target.contains(document.activeElement)) {
                  setIsPanelOpen?.(false);
                }
              }, 0);
            }}
          >
            <Button
              variant="primary"
              className={` font-normal !text-base py-[4px] !w-full`}
              onClick={() => {
                router.push("/shopping-list");
                setIsPanelOpen?.(false);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleNavigation();
                }
              }}
              aria-label="Edit list"
              aria-disabled={
                products?.length === 0
              }
              tabIndex={
                products?.length === 0
                  ? -1
                  : 0
              }
            >
              Edit List
            </Button>

          </Box>
        </Box>
      )}
    </Box>
  ) : (
    <Box as="div">
      {/* {loader && cartList?.isLoading ? ( */}
      <Loader className="fixed inset-0 bg-[#fff] bg-opacity-70 z-[9999] flex items-center justify-center" />
      {/* ) : null} */}
    </Box>
  );
};

export default CartSidePanel;